/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { BackButton } from '../components/BackButton';
import ContactCard from '../components/ContactCard';
import { PageContainer } from '../components/layout/PageContainer';
import YesNoAction from '../components/YesNoAction';
import { selectContactInfo, selectUserContactDetails } from '../features/azure-b2c/storage';
import { TestIds } from '../testIds';

export const CampaignSuccess = () => {
  const userDetails = useSelector(selectUserContactDetails);
  const navigate = useNavigate();
  const location = useLocation();
  const title: string = location.state?.campaignTitle;
  const relationshipOwner = useSelector(selectContactInfo);

  return (
    <PageContainer data-testid={TestIds.pages.campaignSuccess}>
      <BackButton text='Back to Sales Agreement' onClick={() => navigate('/agreements')} />
      <YesNoAction
        display='Sales Agreement Submitted'
        subheading={
          <Typography variant='h4' sx={{ mt: 4, mb: 2 }}>
            Thanks {userDetails?.firstName}!
          </Typography>
        }
        body={
          <Typography variant='body2'>
            Your schedule for <b>{title}</b> has been submitted.
            <br />
            <br />
            Farmlands will be in contact to finalise any additional details required, and you'll
            receive an email confirmation shortly.
            <br />
            <br />
            Your Sales Agreement will be visible in FarmlandsPRO once it has been processed by the
            Farmlands Team.
          </Typography>
        }
      />
      <ContactCard
        sx={{ mt: 4 }}
        title='If you have any questions please contact your Farmlands representative.'
        data-testid={TestIds.components.contactCard.card}
        {...relationshipOwner}
      />
    </PageContainer>
  );
};
